class BuildYourPossum {
  constructor(container) {
    this.container = container;
    this.sectionId = this.container.dataset.sectionId;
    this.tabHeaders = this.container.querySelectorAll(
      ".build-your-possum__tab-header"
    );
    this.tabPanels = this.container.querySelectorAll(
      ".build-your-possum__tab-panel"
    );
    this.exploreButtons = this.container.querySelectorAll(
      ".build-your-possum__explore-button"
    );

    this.init();
  }

  init() {
    // Set initial active button text
    this.updateExploreButton();

    // Add click event listeners to tab headers
    this.tabHeaders.forEach((header) => {
      header.addEventListener("click", this.handleTabClick.bind(this));
    });
  }

  handleTabClick(event) {
    const header = event.currentTarget;
    const tab = header.getAttribute("data-tab");

    // Remove active class from all headers and panels
    this.tabHeaders.forEach((h) => h.classList.remove("active"));
    this.tabPanels.forEach((p) => p.classList.remove("active"));

    // Add active class to clicked header and corresponding panel
    header.classList.add("active");
    this.container
      .querySelector(`.build-your-possum__tab-panel--${tab}`)
      .classList.add("active");

    // Update the explore button text
    this.updateExploreButton();
  }

  updateExploreButton() {
    const activeTab = this.container.querySelector(
      ".build-your-possum__tab-header.active"
    );

    if (activeTab) {
      const exploreText = activeTab.getAttribute("data-explore-text");
      const tab = activeTab.getAttribute("data-tab");
      const exploreButton = this.container.querySelector(
        `.build-your-possum__tab-panel--${tab} .build-your-possum__explore-button`
      );

      if (exploreButton && exploreText) {
        exploreButton.textContent = exploreText;
      }
    }
  }

  // For use with Shopify's section:unload event
  onUnload() {
    this.tabHeaders.forEach((header) => {
      header.removeEventListener("click", this.handleTabClick);
    });
  }
}

// Initialize all Build Your Possum sections on the page
const buildYourPossumSections = {};

function initBuildYourPossumSection(container) {
  const sectionId = container.dataset.sectionId;
  if (sectionId) {
    buildYourPossumSections[sectionId] = new BuildYourPossum(container);
  }
}

// Initialize on DOM ready
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".build-your-possum");
  sections.forEach((section) => {
    initBuildYourPossumSection(section);
  });
});

// For Shopify theme editor
if (typeof Shopify !== "undefined" && Shopify.designMode) {
  document.addEventListener("shopify:section:load", function (event) {
    const container = event.target.querySelector(".build-your-possum");
    if (container) {
      initBuildYourPossumSection(container);
    }
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const sectionId =
      event.target.querySelector(".build-your-possum")?.dataset.sectionId;
    if (sectionId && buildYourPossumSections[sectionId]) {
      buildYourPossumSections[sectionId].onUnload();
      delete buildYourPossumSections[sectionId];
    }
  });

  document.addEventListener("shopify:section:select", function (event) {
    const sectionId =
      event.target.querySelector(".build-your-possum")?.dataset.sectionId;
    if (sectionId && buildYourPossumSections[sectionId]) {
      // Re-initialize when section is selected in the theme editor
      buildYourPossumSections[sectionId].init();
    }
  });
}
